import { AUTH_LOGIN, AUTH_LOGOUT, AUTH_ERROR, AUTH_CHECK } from 'react-admin';
import { login } from './api';

export default (type, params) => {
  if (type === AUTH_LOGIN) {
    const { username, password } = params;
    return login(username, password).then(res => localStorage.setItem('token', res.data.token));
  }
  if (type === AUTH_LOGOUT) {
    localStorage.removeItem('token');
    return Promise.resolve();
  }
  if (type === AUTH_ERROR) {
    const { status } = params.response;
    if (status === 401 || status === 403) {
      localStorage.removeItem('token');
      return Promise.reject();
    }
    return Promise.resolve();
  }
  if (type === AUTH_CHECK) {
    return localStorage.getItem('token') ? Promise.resolve() : Promise.reject();
  }

  return Promise.resolve();
};



// WEBPACK FOOTER //
// ./src/lib/authProvider.js